import ErrorLabel from './ErrorLabel.vue';

// @ts-ignore
ErrorLabel.install = (Vue) => {
  Vue.component((ErrorLabel as any).options.name, ErrorLabel);
};

export default ErrorLabel;
